import Immutable from 'immutable';
import { createSelector } from 'reselect';
import { selectListEntities } from './EntitiesSelector';
import { LIST_CATEGORIES } from '../constants/ListsConstants';

const getListIds = state => state.getIn(['lists', 'lists', 'items'], Immutable.List());
const getPagination = state => state.getIn(['lists', 'lists', 'pagination'], Immutable.Map());
const getListItemTransactions = state => state.getIn(['lists', 'listItemTransactions'], Immutable.Map());

const getCurrentUserListProp = (prop, defaultValue) => category => state =>
  state.getIn(['lists', 'currentUserLists', category, prop], defaultValue);
const getCurrentUserListIds = getCurrentUserListProp('items', Immutable.List());
const getCurrentUserListPagination = getCurrentUserListProp('pagination', Immutable.List());
const getCurrentUserListLoading = getCurrentUserListProp('isFetching', false);

export const selectLists = createSelector([selectListEntities, getListIds], (listEntities, listIds) =>
  listIds.map(id => listEntities.get(id.toString()))
);

export const selectListsPagination = createSelector([getPagination], pagination => pagination);

export const selectDraftLists = createSelector(
  [selectListEntities, getCurrentUserListIds(LIST_CATEGORIES.DRAFT_NOT_PUBLISHED)],
  (listEntities, listIds) => listIds.map(id => listEntities.get(id.toString()))
);

export const selectDraftListsPagination = createSelector(
  [getCurrentUserListPagination(LIST_CATEGORIES.DRAFT_NOT_PUBLISHED)],
  pagination => pagination
);

export const selectPublishedLists = createSelector(
  [selectListEntities, getCurrentUserListIds(LIST_CATEGORIES.PUBLISHED)],
  (listEntities, listIds) => listIds.map(id => listEntities.get(id.toString()))
);

export const selectPublishedListsPagination = createSelector(
  [getCurrentUserListPagination(LIST_CATEGORIES.PUBLISHED)],
  pagination => pagination
);

export const selectDraftListsLoading = createSelector(
  [getCurrentUserListLoading(LIST_CATEGORIES.DRAFT_NOT_PUBLISHED)],
  isFetching => isFetching
);

export const selectPublishedListsLoading = createSelector(
  [getCurrentUserListLoading(LIST_CATEGORIES.PUBLISHED)],
  isFetching => isFetching
);

export const selectListItemTransactions = createSelector(
  [getListItemTransactions],
  listItemTransactions => listItemTransactions
);

export default {
  selectLists,
  selectListsPagination,
  selectDraftLists,
  selectDraftListsPagination,
  selectDraftListsLoading,
  selectPublishedLists,
  selectPublishedListsPagination,
  selectPublishedListsLoading,
  selectListItemTransactions
};
